import React from "react";
import {
  getSelectedLocations,
  getLocationsFilterOptions,
  getSelectedLocationDescription,
} from "state/ui/location-filter/selectors";
import {
  setLocationsFilterOptions,
  setSelectedLocations,
} from "../../state/ui/location-filter/actions";
import vd from "lib/vd";
import { connect } from "react-redux";
import PopoverMenu from "components/popover/menu";
import "./styles.scss";
import { Box, Heading, Stack } from "@towersystems/towersystems-design-system";
import Button from "components/button";
import ButtonGroup from "components/button-group";
import Icon from "../../components/icon";
import classnames from "classnames";

const LocationFilterDropdown = ({
  selectedLocations,
  locationFilterOptions,
  setLocationsFilterOptions,
  setSelectedLocations,
  description,
}) => {
  const [checked, setChecked] = React.useState([]);
  const [isVisible, setIsVisible] = React.useState(false);

  React.useEffect(() => {
    if (selectedLocations.length === 0) {
      vd.location()
        .listAll()
        .then((locations) => {
          setLocationsFilterOptions(locations || []);
        })
        .catch((err) => console.log);
    }
  }, []);

  React.useEffect(() => {
    if (isVisible) {
      setChecked(selectedLocations);
    } else {
      setChecked([]);
    }
  }, [selectedLocations.length, isVisible]);

  const handleOnSubmit = () => {
    setSelectedLocations(checked);
    setIsVisible(false);
  };

  const canActivate = locationFilterOptions.length > 1;

  const activatorMarkup = (
    <div
      className={classnames(
        "location-filter-dropdown__activator",
        !canActivate && "not-active"
      )}
      onClick={() => canActivate && setIsVisible(true)}
    >
      <Icon name="FaLocationDot" type="fa6" marginRight={10} />
      {description}
      {locationFilterOptions.length > 1 && (
        <Icon name="FaCaretDown" type="fa" marginLeft={10} size={10} />
      )}
    </div>
  );

  const isDisabled = checked === selectedLocations;

  const popoverContent = (
    <Box className="location-filter-dropdown__content" padding="large">
      <Box
        paddingBottom="large"
        justifyContent="spaceBetween"
        alignItems="center"
        display="flex"
      >
        <Heading level="3">Select Locations</Heading>
        {checked.length >= 1 ? (
          <Box>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                setChecked([]);
              }}
              text
            >
              Clear all
            </Button>
          </Box>
        ) : undefined}
      </Box>
      <Box>
        <Stack space="medium">
          {locationFilterOptions.map((location) => {
            const isChecked = checked.includes(location.locationCode);
            return (
              <div key={location.locationCode}>
                <input
                  type="checkbox"
                  checked={isChecked}
                  value={location.locationCode}
                  onChange={() => {
                    if (isChecked) {
                      setChecked(
                        checked.filter((l) => l !== location.locationCode)
                      );
                    } else {
                      setChecked([...checked, location.locationCode]);
                    }
                  }}
                />
                <label>{location.name}</label>
              </div>
            );
          })}
        </Stack>
      </Box>
      <ButtonGroup
        paddingTop="large"
        display="flex"
        alignItems="center"
        justifyContent="spaceBetween"
      >
        <Button
          disabled={isDisabled}
          width="full"
          onClick={handleOnSubmit}
          primary
        >
          Apply
        </Button>
        <Button width="full" onClick={() => setIsVisible(false)}>
          Cancel
        </Button>
      </ButtonGroup>
    </Box>
  );

  return (
    <div>
      <PopoverMenu
        className="location-filter-dropdown"
        enterExitTransitionDurationMs={50}
        onOuterAction={() => setIsVisible(false)}
        isOpen={isVisible}
        showArrow={true}
        content={popoverContent}
      >
        {activatorMarkup}
      </PopoverMenu>
    </div>
  );
};

export default connect(
  (state) => ({
    selectedLocations: getSelectedLocations(state),
    locationFilterOptions: getLocationsFilterOptions(state),
    description: getSelectedLocationDescription(state),
  }),
  {
    setLocationsFilterOptions,
    setSelectedLocations,
  }
)(LocationFilterDropdown);
